import { lazy } from 'react'

const AdvancesIndex = lazy<React$ComponentType>(() => import('d2/screens/Deals/DealsIndex'))
export default AdvancesIndex
